<template>
  <div
    class="sample-details-card sample-in-process is-clickable"
    role="button"
    tabindex="0"
    @click="navigateToSampleType"
    @keydown.enter.prevent="navigateToSampleType"
    @keydown.space.prevent="navigateToSampleType"
  >
    <div class="icon-in_process">
      <img :src="inProgresIconSvg" alt="process icon" />
    </div>
    <div class="sample-in-process-content">
      <h4>{{ getSampleValue }}</h4>
      <p>
        {{ $t('lastSamples.inProcess') }}
      </p>
    </div>
    <span class="sample-card-arrow f7-icons" aria-hidden="true">
      chevron_right
    </span>
  </div>
</template>

<script>
import inProgresIconSvg from '@/static/icons/en_progreso.svg';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'InProcessCard',
  props: {
    sampleType: { type: Object, required: true },
    firstSampleTypeKey: { type: String, required: true },
  },
  data() {
    return {
      sampleTypesRouteMap: {
        Agronomía: 'AgronomySamplesPage',
        Alimentaria: 'FoodSamplesPage',
        'Medio Ambiente': 'EnvironmentSamplesPage',
        Minería: 'MiningSamplesPage',
        'Salud y Seguridad': 'HealthAndSecuritySamplesPage',
      },
    };
  },
  computed: {
    inProgresIconSvg: () => inProgresIconSvg,
    getSampleValue() {
      return this.firstSampleTypeKey
        ? this.sampleType[this.firstSampleTypeKey]?.in_process || 0
        : 0;
    },
  },
  methods: {
    navigateToSampleType() {
      try {
        // SOLO navegar con el query parameter
        // El filtrado lo maneja el componente de destino
        this.$f7router.navigate({
          name:
            this.sampleTypesRouteMap[this.firstSampleTypeKey] ??
            'DashboardHome',
          query: { dashboardInProcess: 'true' },
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
  },
};
</script>

<style lang="scss">
.generic-sample-card {
  .sample-details-card.sample-in-process {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 6px;
      background: rgba(4, 80, 159, 0.4);
    }

    .icon-in_process {
      width: 34px;
      height: 34px;
      flex-shrink: 0;
      background-color: var(--primary-Blue-20, #c2d8f0);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        padding-bottom: 1px;
      }
    }

    .sample-in-process-content {
      display: flex;
      flex: 1;
      min-width: 0;
      align-items: center;
      gap: 8px;

      h4 {
        color: var(--Primary-Blue-60, #04509f);
        font-size: 21px;
        font-style: normal;
        font-weight: 700;
        line-height: 1;
        padding-bottom: 2px;
        letter-spacing: -0.02em;
        margin: 0;
      }

      p {
        color: var(--Primary-Blue-70, #00346a);
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.5;
        text-decoration: none;
        margin: 0;
        white-space: nowrap;
      }
    }
  }
}
</style>
